
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SetupRosterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Roster"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RosterFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"team"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"athletes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RosterLinkFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"athlete"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AthleteFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contexts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AthleteContextFragment"},"directives":[]}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"athleteContexts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RosterAthleteContextFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"athleteContext"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FullAthleteContextFragment"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":739}};
    doc.loc.source = {"body":"#import './RosterFragment.graphql'\n#import './TeamFragment.graphql'\n#import './RosterLinkFragment.graphql'\n#import './AthleteFragment.graphql'\n#import './AthleteContextFragment.graphql'\n#import './RosterAthleteContextFragment.graphql'\n#import './FullAthleteContextFragment.graphql'\n\nfragment SetupRosterFragment on Roster {\n  ...RosterFragment\n  team {\n    ...TeamFragment\n  }\n  athletes {\n    items {\n      ...RosterLinkFragment\n      athlete {\n        ...AthleteFragment\n        contexts {\n          items {\n            ...AthleteContextFragment\n          }\n        }\n      }\n    }\n  }\n  athleteContexts {\n    items {\n      ...RosterAthleteContextFragment\n      athleteContext {\n        ...FullAthleteContextFragment\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./RosterFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./TeamFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./RosterLinkFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./AthleteFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./AthleteContextFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./RosterAthleteContextFragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./FullAthleteContextFragment.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SetupRosterFragment"] = oneQuery(doc, "SetupRosterFragment");
        
